module.exports = __webpack_public_path__ + "img/logo.5d4b1747.png";